import { useLingui } from '@lingui/react/macro';
import { useDonationCount } from '../donation-count';
import { DonationOdometer } from './donation-odometer';

/**
 * The live-donations card of the Solutions hero: layout and copy only. The number it shows counts
 * from the moment the visitor entered the site, not from when this card mounted — see
 * `-components/donation-count.ts`.
 */
export function LiveDonations() {
	const { t } = useLingui();
	const count = useDonationCount();

	// Stacked below `sm` out of necessity: the odometer is three 74px tiles that never shrink, which
	// leaves the copy less than its longest word on a phone and scrolls the whole page sideways.
	return (
		<div className="bg-apricot flex flex-col items-start gap-4 rounded-2xl p-3 sm:flex-row sm:items-center sm:gap-10 sm:px-6">
			<DonationOdometer count={count} />
			<p className="text-ink/80 max-w-[19.5rem] min-w-0 text-sm leading-[1.5] tracking-[-0.02em] sm:text-base">
				{t`Donations we have received while you have been on this site.`}
			</p>
		</div>
	);
}
